export default "__VITE_ASSET__BIRzAEDs__"